import TailwindIcon from "./icons/TailwindIcon";
import JsIcon from "./icons/JsIcon";
import CssIcon from "./icons/CssIcon";
import HtmlIcon from "./icons/HtmlIcon";
import ReactIcon from "./icons/ReactIcon";
import PythonIcon from "./icons/PythonIcon";
import DjangoIcon from "./icons/DjangoIcon";
import GitIcon from "./icons/GitIcon";
import ScrumIcon from "./icons/ScrumIcon";
import BootIcon from "./icons/BootIcon";
import TypescriptIcon from "./icons/TypescriptIcon";
import MuiIcon from "./icons/MuiIcon";
import ViteIcon from "./icons/ViteIcon";

export const TAGS = {
  TAILWIND: {
    name: "Tailwind",
    class: "bg-[#003159] text-white",
    icon: <TailwindIcon className="h-6 w-6" />,
  },
  JS: {
    name: "Javascript",
    class: "bg-[#ffc619] text-white",
    icon: <JsIcon className="h-6 w-6" />,
  },
  CSS: {
    name: "Css",
    class: "bg-[#003159] text-white",
    icon: <CssIcon className="h-6 w-6" />,
  },
  HTML: {
    name: "Html",
    class: "bg-[#e27400] text-white",
    icon: <HtmlIcon className="h-6 w-6" />,
  },
  REACT: {
    name: "React",
    class: "bg-[#016985] text-white",
    icon: <ReactIcon className="h-6 w-6" />,
  },
  PYTHON: {
    name: "Python",
    class: "bg-[#003159] text-white",
    icon: <PythonIcon className="h-6 w-6" />,
  },
  DJANGO: {
    name: "Django",
    class: "bg-[#092e20] text-white",
    icon: <DjangoIcon className="h-6 w-6" />,
  },
  GIT: {
    name: "Git ",
    class: "bg-[#f6f6f6] text-white",
    icon: <GitIcon className="h-6 w-6" />,
  },
  SCRUM: {
    name: "Scrum",
    class: "bg-white text-white",
    icon: <ScrumIcon className="h-6 w-6" />,
  },
  BOOTSTRAP: {
    name: "Bootstrap",
    class: "bg-[#452c6e] text-white",
    icon: <BootIcon className="h-6 w-6" />,
  },
  TYPESCRIPT: {
    name: "Typescript",
    class: "bg-[#007acc] text-white",
    icon: <TypescriptIcon className="h-6 w-6" />,
  },
  MUI: {
    name: "MUI",
    class: "bg-[#007fff] text-white",
    icon: <MuiIcon className="h-6 w-6" />,
  },
  VITE: {
    name: "Vite",
    class: "bg-[#646cff] text-white",
    icon: <ViteIcon className="h-6 w-6" />,
  },
};
